import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useCallback, useMemo, useEffect } from 'react';
import { debounce } from '@mui/material';
import { AutosizedTextField } from './AutosizedTextField';
export const DebouncedTextField = (props) => {
    'use no memo';
    // Existing memoization could not be preserved
    // Inferred dependency not present in source.
    const [value, setValue] = useState(props.value ?? '');
    // memoize the callback with useCallback
    // we need it since it's a dependency in useMemo below
    const sendRequest = useCallback((e) => {
        props.onChange && props.onChange(e);
        //console.log("Changed value:", e);
    }, []);
    // memoize the debounce call with useMemo
    const debouncedSendRequest = useMemo(() => {
        return debounce(sendRequest, props.debounceMs ?? 1000);
    }, [sendRequest]);
    const onChange = (e) => {
        const value = e.target.value;
        setValue(value);
        debouncedSendRequest(e);
    };
    // Update if new value provided externally
    useEffect(() => {
        if (!props.value)
            return;
        setValue(props.value);
    }, [props.value]);
    return _jsx(AutosizedTextField, { ...props, onChange: onChange, value: value });
};
